import React from "react";
import PropTypes from "prop-types";
import { clx } from "../../utils/Helpers";

import "./_Card.scss";

const Card = ({ title, subtitle, children, footer, classNames }) => {
  return (
    <div className={clx("card-container", classNames.root)}>
      {(title || subtitle) && (
        <div className={clx("card-container__header", classNames.header)}>
          <div className="card-container__header__content">
            <div>
              {title ? (
                <div
                  className={clx(
                    "card-container__header__title",
                    classNames.title,
                  )}
                >
                  {title}
                </div>
              ) : null}
              {subtitle ? (
                <div
                  className={clx(
                    "card-container__header__subtitle",
                    classNames.subtitle,
                  )}
                >
                  {subtitle}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
      <div className={clx("card-container__body", classNames.body)}>
        {children}

        {footer && (
          <div className={clx("card-container__footer", classNames.footer)}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  classNames: PropTypes.object,
};

Card.defaultProps = {
  subtitle: null,
  footer: null,
  classNames: {},
};
